<h2 mat-dialog-title>{{ data?.title || 'Add Staff Member' }}</h2>

<mat-dialog-content>
  <form [formGroup]="personForm">
    <div class="dialog-body" fxLayout="column" fxLayoutGap="16px">
      <div class="lookup-intro">Search all people in the system, then choose one person to send an approval request.</div>

      <mat-form-field>
        <mat-label>Search Existing People</mat-label>
        <input matInput formControlName="selectedPerson" [matAutocomplete]="personAutocomplete">
        <mat-autocomplete #personAutocomplete="matAutocomplete" [displayWith]="displayPerson.bind(this)">
          <mat-option *ngFor="let personOption of matchingPeople" [value]="personOption">
            {{ displayPerson(personOption) }}
          </mat-option>
        </mat-autocomplete>
        <mat-hint>Type at least 3 characters to search.</mat-hint>
        <mat-error *ngIf="showSelectedPersonRequiredError()">Select an existing person.</mat-error>
        <mat-error *ngIf="showSelectedPersonLookupError()">{{ selectedPersonErrorMessage }}</mat-error>
      </mat-form-field>

      <div class="lookup-empty" *ngIf="searchCompleted && !matchingPeople.length">No matching people were found.</div>

      <div class="selected-person-summary" *ngIf="selectedPerson as currentPerson">
        <div><strong>Selected Person:</strong> {{ displayPerson(currentPerson) }}</div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">Send Approval Request</button>
</mat-dialog-actions>
